// import { Injectable } from '@angular/core';
// import { CanMatch, Route, Router } from '@angular/router';
// import { AuthService } from '../services/auth.service';
// import { UserProfile } from '../services/token';

// @Injectable({ providedIn: 'root' })
// export class RoleGuard implements CanMatch {
//   constructor(private auth: AuthService, private router: Router) {}

//   canMatch(route: Route): boolean {
//     const expectedProfiles = route.data?.['profiles'] as
//       | UserProfile[]
//       | undefined;

//     const profile = this.auth.profile;
//     const isLoggedIn = this.auth.isLoggedIn;

//     if (!isLoggedIn || !profile) {
//       this.router.navigate(['/login']);
//       return false;
//     }

//     if (!expectedProfiles || expectedProfiles.length === 0) {
//       this.redirectByProfile(profile);
//       return false;
//     }

//     if (expectedProfiles.includes(profile)) {
//       return true;
//     }

//     this.redirectByProfile(profile);
//     return false;
//   }

//   private redirectByProfile(profile: UserProfile): void {
//     switch (profile) {
//       case 'SALARIE':
//         this.router.navigate(['/employee']);
//         break;
//       case 'ADMIN_ENTREPRISE':
//         this.router.navigate(['/admin-entreprise']);
//         break;
//       case 'SUPER_ADMIN':
//         this.router.navigate(['/admin-global']);
//         break;
//       default:
//         this.router.navigate(['/login']);
//     }
//   }
// }
import { Injectable } from '@angular/core';
import { CanMatch, Route, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserProfile, UserRole } from '../services/token';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanMatch {
  constructor(private auth: AuthService, private router: Router) {}

  canMatch(route: Route): boolean {
    const expectedProfiles = route.data?.['profiles'] as
      | UserProfile[]
      | undefined;
    const expectedRoles = route.data?.['roles'] as UserRole[] | undefined;

    //  si pas connecté
    if (!this.auth.isLoggedIn || !this.auth.profile) {
      this.router.navigate(['/login']);
      return false;
    }

    // si le profil ne correspond pas
    if (expectedProfiles && !expectedProfiles.includes(this.auth.profile)) {
      this.redirectByProfile();
      return false;
    }

    // Si roles attendus
    if (expectedRoles && expectedRoles.length > 0) {
      // ADMIN_ENTREPRISE bypass la vérification des rôles
      if (this.auth.profile === 'ADMIN_ENTREPRISE') {
        return true;
      }

      // Pour SALARIE (ou autre profil), vérifier les rôles
      if (!this.auth.hasAnyRole(expectedRoles)) {
        this.redirectByProfile();
        return false;
      }
    }

    //  accès autorisé
    return true;
  }

  private redirectByProfile(): void {
    // utilise le AuthService pour redirection selon profil
    switch (this.auth.profile) {
      case 'SALARIE':
        this.router.navigate(['/salarie']);
        break;
      case 'ADMIN_ENTREPRISE':
        this.router.navigate(['/admin-entreprise']);
        break;
      case 'SUPER_ADMIN':
        this.router.navigate(['/admin-global']);
        break;
      default:
        this.router.navigate(['/login']);
    }
  }
}
